











/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            open: false,
        };
    },

    created() {
        window.addEventListener("click", this.close);
    },

    methods: {
        toggle() {
            this.open = !this.open;
        },

        close(e) {
            if (!this.$el.contains(e.target)) {
                this.open = false;
            }
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FaqItem extends Vue {};

